import React from "react";
import { hot } from "react-hot-loader/root";
import { isRootSubdomain } from "common/utils/url";
import {
  useCurrentAdminQuery,
  useCurrentUserQuery,
} from "../generated/graphql";
import FullPageLoadingScreen from "./Common/FullPageLoadingScreen";
import { RootDomainRoutes } from "./RootDomainRoutes";
import { AccountSubdomainRoutes } from "./SubdomainRoutes";

// we have to export this in isolation so that hot reloading works
export const MainRoutes = hot(() => {
  const { loading, data } = useCurrentUserQuery();
  const { loading: loadingAdmin, data: adminData } = useCurrentAdminQuery();

  if (loading || loadingAdmin) return <FullPageLoadingScreen />;

  const props = {
    user: data?.currentUser,
    admin: adminData?.currentAdmin,
  };

  const isOnRootSubdomain = isRootSubdomain(window.location.href);

  return isOnRootSubdomain ?
      <RootDomainRoutes {...props} />
    : <AccountSubdomainRoutes {...props} />;
});
